import { render, staticRenderFns } from "./AbortoProcessoPage.vue?vue&type=template&id=2b0bbfc6&"
import script from "./AbortoProcessoPage.vue?vue&type=script&lang=js&"
export * from "./AbortoProcessoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports